import { MessageDescriptor } from 'react-intl';
import {
    OE_DATA_ORGANIZATIONS_COLUMN_ACTIVE_STATUS_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_CREATED_AT_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_EXCHANGE_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_FISCAL_YEAR_END_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_HQ_CITY_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_HQ_COUNTRY_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_HQ_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_INDUSTRY_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_IR_WEBSITE_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_ISIN_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_MARKET_CAP_CURRENCY_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_MARKET_CAP_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_NAME_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_NOTES_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_ORGANIZATION_TYPE_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_PARENT_ORGANIZATION_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_SECTOR_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_SHORT_NAME_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_TICKER_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_UPDATED_AT_TEXT,
    OE_DATA_ORGANIZATIONS_COLUMN_WEBSITE_TEXT,
} from '../oe-data.text';

export const OE_DATA_ORGANIZATIONS_COLUMNS_STORAGE_KEY = 'OeDataOrganizationListView';

export type TOeDataOrganizationColumnId =
    | 'name'
    | 'shortName'
    | 'organizationType'
    | 'parentOrganization'
    | 'hq'
    | 'hqCity'
    | 'hqCountry'
    | 'website'
    | 'notes'
    | 'createdAt'
    | 'updatedAt'
    | 'ticker'
    | 'exchange'
    | 'isin'
    | 'marketCap'
    | 'marketCapCurrency'
    | 'sector'
    | 'industry'
    | 'fiscalYearEnd'
    | 'irWebsite'
    | 'activeStatus';

export const MANDATORY_OE_DATA_ORGANIZATION_COLUMN_ID: TOeDataOrganizationColumnId = 'name';

export const OE_DATA_ORGANIZATION_COLUMNS: TOeDataOrganizationColumnId[] = [
    'name',
    'shortName',
    'organizationType',
    'parentOrganization',
    'hq',
    'hqCity',
    'hqCountry',
    'website',
    'notes',
    'createdAt',
    'updatedAt',
    'ticker',
    'exchange',
    'isin',
    'marketCap',
    'marketCapCurrency',
    'sector',
    'industry',
    'fiscalYearEnd',
    'irWebsite',
    'activeStatus',
];

export const DEFAULT_OE_DATA_ORGANIZATION_COLUMNS: TOeDataOrganizationColumnId[] = [
    'name',
    'shortName',
    'organizationType',
    'parentOrganization',
    'hq',
    'ticker',
    'activeStatus',
];

export const OE_DATA_ORGANIZATION_COLUMN_TITLES: Record<TOeDataOrganizationColumnId, MessageDescriptor> = {
    name: OE_DATA_ORGANIZATIONS_COLUMN_NAME_TEXT,
    shortName: OE_DATA_ORGANIZATIONS_COLUMN_SHORT_NAME_TEXT,
    organizationType: OE_DATA_ORGANIZATIONS_COLUMN_ORGANIZATION_TYPE_TEXT,
    parentOrganization: OE_DATA_ORGANIZATIONS_COLUMN_PARENT_ORGANIZATION_TEXT,
    hq: OE_DATA_ORGANIZATIONS_COLUMN_HQ_TEXT,
    hqCity: OE_DATA_ORGANIZATIONS_COLUMN_HQ_CITY_TEXT,
    hqCountry: OE_DATA_ORGANIZATIONS_COLUMN_HQ_COUNTRY_TEXT,
    website: OE_DATA_ORGANIZATIONS_COLUMN_WEBSITE_TEXT,
    notes: OE_DATA_ORGANIZATIONS_COLUMN_NOTES_TEXT,
    createdAt: OE_DATA_ORGANIZATIONS_COLUMN_CREATED_AT_TEXT,
    updatedAt: OE_DATA_ORGANIZATIONS_COLUMN_UPDATED_AT_TEXT,
    ticker: OE_DATA_ORGANIZATIONS_COLUMN_TICKER_TEXT,
    exchange: OE_DATA_ORGANIZATIONS_COLUMN_EXCHANGE_TEXT,
    isin: OE_DATA_ORGANIZATIONS_COLUMN_ISIN_TEXT,
    marketCap: OE_DATA_ORGANIZATIONS_COLUMN_MARKET_CAP_TEXT,
    marketCapCurrency: OE_DATA_ORGANIZATIONS_COLUMN_MARKET_CAP_CURRENCY_TEXT,
    sector: OE_DATA_ORGANIZATIONS_COLUMN_SECTOR_TEXT,
    industry: OE_DATA_ORGANIZATIONS_COLUMN_INDUSTRY_TEXT,
    fiscalYearEnd: OE_DATA_ORGANIZATIONS_COLUMN_FISCAL_YEAR_END_TEXT,
    irWebsite: OE_DATA_ORGANIZATIONS_COLUMN_IR_WEBSITE_TEXT,
    activeStatus: OE_DATA_ORGANIZATIONS_COLUMN_ACTIVE_STATUS_TEXT,
};
